import { ShippingTracking } from '@reveni-io/reveni-ui'

import ParcelsSection from '../ParcelsSection/ParcelsSection'
import { hasParcels } from './helpers'
import * as Styles from './styles'

const ShippingTrackingSection = ({ parcels, storeId, trackingNumbers, onOpenClaim, orderTrackingPageUrl }) => {
  if (hasParcels(parcels)) {
    return (
      <>
        <Styles.CustomDivider />
        <ParcelsSection parcels={parcels} storeId={storeId} orderTrackingPageUrl={orderTrackingPageUrl} />
      </>
    )
  }

  return (
    <>
      {trackingNumbers.length > 0 && <Styles.CustomDivider />}
      <ShippingTracking trackingNumbers={trackingNumbers} onOpenClaim={onOpenClaim} />
    </>
  )
}

export default ShippingTrackingSection
